import React from 'react';
import { Shield, Shuffle, Award, Users, Package, Sparkles, Star, Zap, Check, Heart, Lock, Unlock } from 'lucide-react';
import { ProductGallery } from './ProductGallery';

const iconMap = {
  Shield, Shuffle, Award, Users, Package, Sparkles, Star, Zap, Check, Heart, Lock, Unlock
};

export const FeaturesSection = ({ featuresData, galleryData, selectedColor }) => {
  if (!featuresData) return null;
  
  const getIcon = (iconName) => {
    return iconMap[iconName] || Star;
  };

  return (
    <>
      <style jsx>{`
        #features {
          padding-top: 8rem;
          padding-bottom: 8rem;
        }
        
        @media (max-width: 768px) {
          #features {
            padding-top: 3rem;
            padding-bottom: 8rem;
          }
        }
      `}</style>
      <section id="features" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header - Left aligned */}
        <div className="mb-16">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white px-6 py-2 rounded-full border border-orange-500/50 shadow-lg shadow-orange-500/20 mb-4">
            <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
            <span className="gaming-text font-bold text-orange-400 uppercase tracking-widest" style={{ fontSize: '12px' }}>{featuresData.section_badge}</span>
          </div>
          
          {/* Main Heading */}
          <h2 className="gaming-title text-5xl sm:text-6xl font-bold text-gray-900 mb-2 uppercase">
            {featuresData.section_title}
          </h2>
          
          {/* Subtitle with decorative lines */}
          <div className="flex items-center space-x-4">
            <p className="gaming-text text-gray-900 uppercase tracking-wide" style={{ fontSize: '18px' }}>Engineered for Champions</p>
            <div className="h-px flex-1 bg-gradient-to-r from-orange-500 to-transparent max-w-xs"></div>
          </div>
        </div>

        {/* Features and Gallery Layout - Flex container */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
          {/* Left Side - Features Grid (2 columns) */}
          <div className="w-full lg:w-1/2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {featuresData.features?.map((feature, index) => {
                const Icon = getIcon(feature.icon);
                return (
                  <div
                    key={index}
                    className="space-y-3 md:space-y-4"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg border-2 border-green-500 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 md:w-6 md:h-6 text-green-500" />
                    </div>
                    <h3 className="gaming-title text-lg md:text-xl font-bold text-orange-500 uppercase break-words">
                      {feature.title}
                    </h3>
                    <p className="gaming-text text-gray-900 leading-relaxed break-words" style={{ fontSize: '16px', wordWrap: 'break-word', overflowWrap: 'break-word', marginTop: '0px' }}>
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Side - Product Gallery (Independent container) */}
          <div className="w-full lg:w-1/2 relative mt-8 lg:mt-0">
            <div className="lg:-mt-40">
              <ProductGallery galleryData={galleryData} selectedColor={selectedColor} />
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};
